export const AppConstants = {
  INDEX_DB: {
    dbName: 'cliv-v2',
    version: 6,
    store: {
      inspections: 'inspections',
      savedInspections: 'savedInspections',
      images: 'images',
      masterData: 'masterData',
      openedInspection: 'openedInspection',
      locationVerificationDrafts: 'locationVerificationDrafts',
      factoryVisitSessions: 'factoryVisitSessions',
      openSyncLogs: 'openSyncLogs',
      pendingLogs: 'pendingLogs',
    },
    storeConfig: {
      locationVerificationDrafts: { keyPath: 'inspectionId' },
      factoryVisitSessions: { keyPath: 'id' },
      openSyncLogs: { keyPath: 'inspectionId' },
      pendingLogs: { keyPath: 'partId' },
    } as Record<string, { keyPath?: string }>,
  },
  ID_PREFIX: 'newid',
  IMAGE_URL_SEPARATOR: ',',
  REQUEST_ID_HEADER: 'X-Request-Id',
  X_INSPECTOR_TIMEZONE_HEADER: 'X-Inspector-Timezone',
  DEFAULT_MODULE: 'VisualCheck',
  LOCATION_VERIFICATION_CONTROL_POINT_NAMES: [
    'Factory Final Inspection',
    'Factory Inspection',
  ] as const,
  APP_NAME: 'inspect',
};
